import { crearChecklistPorCTService, sesionActualPorCT } from './checklistPorCT';

const BASE = '/cctv';

export const sesionActualCCTV = sesionActualPorCT;

const base = crearChecklistPorCTService(BASE);

export const cctvService = {
    listarCts: base.listarCts,
    checklist: base.checklist,
    responder: base.responder,
    enviarReporte: base.enviarReporte,
    historial: base.historial,
    importarChecklistExcel: base.importarChecklistExcel,
    eliminarChecklist: base.eliminarChecklist,
};

export const descargarPlantillaChecklistCCTV = () => base.descargarPlantilla('plantilla_checklist_cctv.xlsx');

export const descargarReporteCCTV = (ct, sesion = null) => base.descargarReporte(ct, sesion, 'cctv');

export const descargarReporteExcelCCTV = (ct, sesion = null) => base.descargarReporteExcel(ct, sesion, 'cctv');

export const descargarReporteExcelInspectoriaCCTV = (sesion = null) => base.descargarReporteExcelInspectoria(sesion, 'cctv');
